{
  "actions": "Actions",
  "browserConnect": "Connect via Bastion",
  "caeCasVMs": "CAE - CAS / GAE Virtual Machines",
  "caeVrsVMs": "CAE - VRS Virtual Machines",
  "GB": "GB",
  "listOfVMs": "List of virtual machines",
  "myVMs": "My Virtual Machines (VMs)",
  "noVms": "You have no DAS virtual machines.",
  "noVmsP1": "Depending on project needs, having one may complement your analytics.",
  "noVmsP2": "\"Start a new project\" to initiate the process and we will assess if it will meet your needs.",
  "size": "Size",
  "startVM": "Start the virtual machine",
  "startVMtitle": "Start VM",
  "status": "Status",
  "stopVM": "Stop virtual machine",
  "stopVMtitle": "Stop VM",
  "VmLoadError1": "There was a problem loading the virtual machines. Please try again later or contact ",
  "VmLoadErrorLink": "our support team",
  "VmLoadError2": " if the issue persists.",
  "VM": "The VM",
  "VMName": "VM name",
  "VMStarted": "started successfully",
  "VMStarting": "is starting….",
  "VMConnected": "connected successfully",
  "VMStopping": "is stopping (deallocating)….",
  "VMStopped": "stopped (deallocated) successfully",
  "creating": "Creating",
  "starting": "Starting",
  "running": "Running",
  "stopping": "Stopping",
  "stopped": "Stopped",
  "deallocating": "Deallocating",
  "deallocated": "Deallocated",
  "updating": "Updating",
  "failed": "Failed",
  "succeeded": "Succeeded",
  "deleting": "Deleting",
  "migrating": "Migrating"
}
